import React from "react";
import useStore from "../../Store/Store";
import GenericDropdown from "../GenericDropDown";

export const mostRecentStatusOptions = [
  "Any",
  "For sale",
  "Off market",
  "Rental",
  "Pre-foreclosure",
  "Pending",
  "Foreclosed",
  "Sold",
  "Auction",
  "Coming soon",
  "Rent to own",
];


export const mostRecentStatusValueMap = {
  "For sale": "For Sale",
  "Off market": "Off Market",
  "Rental": "Rental",
  "Pre-foreclosure": "Pre-Foreclosure",
  "Pending": "Pending",
  "Foreclosed": "Foreclosed",
  "Sold": "Sold",
  "Auction": "Auction",
  "Coming soon": "Coming Soon",
  "Rent to own": "Rent To Own",
  // Add other mappings as needed
};

function MostRecentStatus() {
  const { mostRecentStatus, setMostRecentStatus, isQueryLoading } = useStore();
  return (
    <GenericDropdown
      options={mostRecentStatusOptions}
      label="Most recent status"
      setter={setMostRecentStatus}
      selectedOptions={mostRecentStatus}
      valueMap={mostRecentStatusValueMap}
      isQueryLoading={isQueryLoading}
    />
  );
}

export default MostRecentStatus;
